import React, { useState } from 'react'
import styled from '@emotion/styled'
import classNames from 'classnames'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons/faChevronRight'

const FormGroup = styled.div`
    .group-title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        cursor: pointer;
        font-size: 0.8rem;
        padding: 5px 1rem;
        margin: 0 -1rem;
        background-color: #444444;
        text-transform: uppercase;
    }

    .group-icon {
        transition: transform 0.2s ease-in-out;
        transform: rotate(0deg);

        &.group-icon--rotate {
            transform: rotate(90deg);
        }
    }

    .group-form {
        padding: 0.5rem 0;
    }

    h6 {
        font-weight: 400;
        font-size: 0.8rem;
        text-transform: uppercase;
    }
`

const Group = ({ title, children }) => {
    const [isOpen, setIsOpen] = useState(false)

    const handleClick = e => {
        e.preventDefault()
        setIsOpen(!isOpen)
    }

    return (
        <FormGroup>
            <hr />
            <a className="group-title" onClick={e => handleClick(e)}>
                <span>{title}</span>
                <FontAwesomeIcon
                    icon={faChevronRight}
                    className={classNames('group-icon', {
                        'group-icon--rotate': isOpen,
                    })}
                />
            </a>

            {isOpen && <div className="group-form">{children}</div>}
        </FormGroup>
    )
}

export default Group
